module.exports = __webpack_public_path__ + "img/detail_fix_new.9645cf9d.png";